import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'MyTypes';

import { Organization } from '@portal/common/types';

import { getSessionAccount } from '../session/selectors';

export const getOrganization = (state: RootState): Organization => state.organization;

export const getOrganizationId = createSelector(
    getOrganization,
    (organization) => organization?.id
);

export const isPharmaProductSearchEnabled = createSelector(
    getOrganization,
    (organization) => organization?.pharma_products_search_is_enabled ?? false
);

export const isAiChatEnabled = createSelector(
    getOrganization,
    getSessionAccount,
    (organization, account) =>
        (organization?.ai_chat_is_enabled && account?.ai_chat_is_enabled) ?? false
);
